import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';

import { selectors, useAppSelector } from 'state/global-state';

import { useCheckoutContext } from './use-checkout-context';

export const useCheckoutLoadingState = () => {
  const {
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isSavingPaymentMethods,
    isOrderLoading,
    isMenuLoading,
    isSelectingStore,
    isFetchingStore,
  } = useCheckoutContext();
  const { isMinimalCartStoreRepricing } = useMinimalCart();

  // Read the pricing state from Redux (set by price order)
  const isPricingOrderFromCart = useAppSelector(selectors.ordering.selectIsPricingOrder);

  // Combine local order loading state with cart pricing state
  const isOrderPriceLoading =
    isOrderLoading || isPricingOrderFromCart || isMinimalCartStoreRepricing;

  const isCheckoutInitializing =
    isOrderPriceLoading ||
    isLoadingPaymentMethods ||
    isMenuLoading ||
    isSelectingStore ||
    isFetchingStore;

  const isPlaceOrderLoading =
    isOrderPriceLoading ||
    isSubmittingOrder ||
    isBuildingCommitOrderPayload ||
    isLoadingPaymentMethods;

  return {
    isOrderPriceLoading,
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isSavingPaymentMethods,
    isCheckoutLoading: isCheckoutInitializing || isSubmittingOrder || isBuildingCommitOrderPayload,
    isPlaceOrderLoading,
  };
};
